import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './NotFound.css';

const NotFound: React.FC = () => {
  useEffect(() => {
    // Set proper HTTP status code for SEO
    document.title = '404 - Page Not Found | TableChat';
    
    // Add meta tag for search engines
    const metaRobots = document.createElement('meta');
    metaRobots.name = 'robots';
    metaRobots.content = 'noindex, nofollow';
    document.head.appendChild(metaRobots);

    return () => {
      // Cleanup meta tag when component unmounts
      document.head.removeChild(metaRobots);
    };
  }, []);

  return (
    <div className="not-found-page">
      <div className="not-found-container">
        <div className="not-found-content">
          <h1 className="not-found-title">404</h1>
          <h2 className="not-found-subtitle">Page Not Found</h2>
          <p className="not-found-description">
            Sorry, the page you're looking for doesn't exist or has been moved.
          </p>
          
          <div className="not-found-actions">
            <Link to="/" className="btn-primary">
              Go to Homepage
            </Link>
            <Link to="/contact" className="btn-secondary">
              Contact Support
            </Link>
          </div>

          <div className="helpful-links">
            <h3>Popular Pages</h3>
            <ul>
              <li><Link to="/pricing">Pricing</Link></li>
              <li><Link to="/signup">Sign Up</Link></li>
              <li><Link to="/faq">FAQ</Link></li>
              <li><Link to="/contact">Contact Us</Link></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
